import { Analytics } from '@cobliteam/analytics';

import { Button, Tooltip } from '@cobliteam/ui/components';

import OpenInNewRoundedIcon from '@mui/icons-material/OpenInNewRounded';

const ClientAreaButton = () => {
  const handleClick = () => {
    Analytics.track('Client area link clicked from the nav button');
    window.open('https://suporte.cobli.co/tickets-view');
  };

  return (
    <Tooltip content='Área do cliente'>
      <Button variant='outlined' color='secondary' size='condensed' icon={<OpenInNewRoundedIcon />} onClick={handleClick} />
    </Tooltip>
  );
};

export default ClientAreaButton;
